import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import './style.scss'

const GenresSelectionGuide: FunctionComponent = () => {
  const { t } = useTranslation()

  return (
    <div className="GenresSelectionGuide__container">
      <h4 className="GenresSelectionGuide__title">
        {t('scheduleCampaignPage.genresSelectionGuide')}
      </h4>

      <div className="GenresSelectionGuide__text-block">
        <p className="GenresSelectionGuide__starttext">
          {t('scheduleCampaignPage.youCanSelectGenres')}
        </p>

        <h5 className="GenresSelectionGuide__subtitle">
          <span role="img" aria-label="thumbs_up">
            &#128077;
          </span>
          &nbsp;{t('scheduleCampaignPage.do')}
        </h5>
        <p className="GenresSelectionGuide__text">
          {t('scheduleCampaignPage.selectMostRelevantGenres')}
        </p>

        <h5 className="GenresSelectionGuide__subtitle">
          <span role="img" aria-label="thumbs_down">
            &#128078;
          </span>
          &nbsp;{t('scheduleCampaignPage.dont')}
        </h5>
        <p className="GenresSelectionGuide__text">
          {t('scheduleCampaignPage.doNotSelect')}
        </p>

        <h5 className="GenresSelectionGuide__subtitle">
          <span role="img" aria-label="point_up">
            &#9757;
          </span>
          &nbsp;{t('scheduleCampaignPage.rememberSubtitle')}
        </h5>
        <p className="GenresSelectionGuide__text">
          {t('scheduleCampaignPage.rememberThatArtists')}
        </p>
      </div>
    </div>
  )
}

export default GenresSelectionGuide
